import React, { useState } from 'react';
import { Form, Input, Button, Icon, Radio, Tooltip, Alert, Select, DatePicker } from 'antd';
import { TransferRequest } from '../../../../models';
import { TransferTypeCard } from './styles';
import { Text4 } from '../../../../styles';
import { PAYMENT_METHODS, PROVIDER_PAYMENT_MODE_MESSAGES } from '../../../../constants';
import { MerchantService } from '../../../../services';
import { handleApiExceptions, printRupee, alertify, isVirtualAccountVisible } from '../../../../app_methods';
import { connect } from 'react-redux';
import { getBankLogo } from '../../../../constants';
import { beneficiaryOrganisationTypes as  organisationTypes } from '../../../../constants';
import './index.scss';
import moment from 'moment';

const transferrequest = new TransferRequest();

let TransferRequestForm = (props) => {
    const [disabledFields, setDisabledFields] = useState({
        "NEFT": false,
        "RTGS": true,
        "IMPS": false,
        "UPI": false,
        "AMAZON_WALLET": false,
    });
    const [isGenerating, setIsGenerating] = useState(false);
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
    const [isSBIAccountNumber, setIsSBIAccountNumber] = useState(false);
    const [selectedVirtualAccount, setSelectedVirtualAccount] = useState(props.current_user.virtual_account);
    const [amount, setAmount] = useState();

    const { form, beneficiary } = props;
    const { getFieldDecorator } = form;
    const validations = TransferRequest.validations;
    const account_type = (beneficiary.beneficiary_type) || null;
    const techSpec = selectedVirtualAccount?.settings?.provider_technical_spec || {};
    const yesbank_ftx_gaming = !!techSpec?.yesbank_ftx_gaming
    const isPowerAxis = !!techSpec?.power_axis;
    const isBeneLEIVisible = amount > 500000000 && isPowerAxis
    const isFtx = !!techSpec.yesbank_ftx; 


    const generateUniqueRequestNumber = () => {
        setIsGenerating(true);
        MerchantService.generate_urn().then(response => {
            if (response.success) form.setFieldsValue({ "unique_request_number": response.data.unique_request_number })
            setIsGenerating(false);
        }).catch(error => {
            setIsGenerating(false);
            handleApiExceptions(error);
        })
    };

    function disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            let payment_mode = form.getFieldValue("payment_mode")
            let txn_limit = props.current_user.tl;
            if (payment_mode in txn_limit && txn_limit[payment_mode] && form.getFieldValue('amount') > txn_limit[payment_mode]) {
                alertify("Oops!", `Amount exceeds transaction limit of Rs. ${parseFloat(txn_limit[payment_mode]).toFixed(2)} for ${payment_mode}.`, "error");
                return;
            }
            props.onSubmit(form.getFieldsValue());
        });
    };

    const handleAmountChange = (e) => {
        const amount = parseFloat(e.target.value);
        if (isNaN(amount)) return;
        setAmount(amount);
        let _disabledFields = { ...disabledFields };

        if (account_type === "upi") {
            if (beneficiary.is_amazon_wallet) {
                _disabledFields["AMAZON_WALLET"] = amount < 1 || amount > 100000;
                delete _disabledFields["UPI"]; // Ensure UPI remains enabled
            } else {
                _disabledFields["UPI"] = amount < 1 || amount > 100000;
                delete _disabledFields["AMAZON_WALLET"]; // Ensure Amazon Wallet remains enabled
            }
        }
        
        else {
            _disabledFields["NEFT"] = amount < 1;
            _disabledFields["RTGS"] = amount < 200000;
            _disabledFields["IMPS"] = amount < 1 || amount > 500000;
        }
        setDisabledFields(_disabledFields);
        if (props.form.getFieldValue("payment_mode") == "RTGS" && amount <= 500000) props.form.setFieldsValue({ payment_mode: "IMPS" });
        else if (props.form.getFieldValue("payment_mode") == "IMPS" && amount > 500000) props.form.setFieldsValue({ payment_mode: "RTGS" });
    };

    const renderTransferTypes = () => {
        let paymentMethods = PAYMENT_METHODS.filter(pm => pm.payment_type === account_type);
    
        if (beneficiary.beneficiary_type === "upi" && beneficiary.is_amazon_wallet) {
            paymentMethods = paymentMethods.map(pm => 
                pm.payment_type === "upi" ? { ...pm, label: "Amazon Wallet" } : pm
            );
        }
    
        return (
            <Radio.Group className="w-100 d-flex">
                {paymentMethods.map((pm, index) => (
                    <TransferTypeCard
                        key={pm.value}
                        className={`mr-1 ${disabledFields[pm.value] ? "transfer-type-card-disabled" : ""}`}
                        style={{ maxWidth: 215 }}
                    >
                        <div className="d-flex align-items-start">
                            <Radio id={index} value={pm.value} disabled={disabledFields[pm.value]} />
                            <label htmlFor={index}>
                                <Text4 className="d-block" style={{ lineHeight: "20px" }}>{pm.label}</Text4>
                                {pm.description && (
                                    <>
                                        <Text4 className="d-block" type="secondary">{pm.description.amount}</Text4>
                                        <Text4 className="d-block" type="secondary">{pm.description.time}</Text4>
                                    </>
                                )}
                            </label>
                        </div>
                    </TransferTypeCard>
                ))}
            </Radio.Group>
        );
    };
     

    const renderURNExtra = () => {
        return (
            <Tooltip title="Generate Random">
                <Icon type="setting" spin={isGenerating} onClick={generateUniqueRequestNumber} />
            </Tooltip>
        )
    };

    const get_payment_method = () => {
        if (beneficiary.beneficiary_type === "upi" && beneficiary.is_amazon_wallet) {
            return "AMAZON_WALLET";
        }
        switch (account_type) {
            case 'bank_account':
                return 'IMPS'
                break
            case 'upi':
                return 'UPI'
                break
        }
    }

    const handleVirtualAccountChange = (value) => {
        const selectedVA = props.current_user.virtual_accounts.find(
            (va) => va.virtual_account_number === value
          );
        setSelectedVirtualAccount(selectedVA);
        if (['SBI'].includes(selectedVA?.provider_code)) {
        setIsSBIAccountNumber(true);
        } else {
            setIsSBIAccountNumber(false);
        }
    }

    return (
        <Form className={`transfer-request-form-wrapper ${props.className}`} onSubmit={onSubmit}>
            {getFieldDecorator("beneficiary_code", {
                initialValue: beneficiary.code || "",
            })(<Input autoComplete='off' hidden />)}

            {getFieldDecorator("queue_on_low_balance", {
                initialValue: props.current_user.eqlb
            })(<Input autoComplete='off' hidden />)}

            <Form.Item label="Source Virtual Account">
                {getFieldDecorator("virtual_account_number", {
                    rules: TransferRequest.validations.virtual_account_number,
                    initialValue: isVirtualAccountVisible(props.current_user.virtual_account) && props.current_user.virtual_account.virtual_account_number
                })(<Select optionLabelProp="label" onChange={handleVirtualAccountChange}>
                    {
                        props.current_user.virtual_accounts.filter(va => va.status == "active" && isVirtualAccountVisible(va)).map((va, index) => {
                            const label = (
                                <span style={{ display: "flex", alignItems: "center" }}>
                                  <img
                                    alt=""
                                    src={getBankLogo(va.provider_code)}
                                    style={{
                                        height: 20,
                                        width: 20,
                                        objectFit: "contain",
                                        marginRight: 8,
                                    }}
                                />
                                  <Text4 type="secondary"> {va.label} - Available Balance: {printRupee(va.balance, 3)}</Text4>
                                </span>
                              );

                            return (
                                <Select.Option label={label} value={va.virtual_account_number} disabled={va.funding_via == 2 && !props.current_user.allow_payouts_via_cc_va ? true : false}>
                                    <div className="d-flex align-items-start">
                                        <div
                                            style={{
                                                display: "flex",
                                                width: 28,
                                                overflow: "hidden",
                                                textAlign: "center",
                                                marginRight: 8,
                                                marginTop: 5
                                            }}
                                        >
                                                <img
                                                    style={{
                                                        margin: "auto",
                                                        width: "auto",
                                                        maxWidth: "100%",
                                                        maxHeight: 28
                                                    }}
                                                    alt=""
                                                    src={getBankLogo(va.provider_code)}
                                                />
                                            </div>
                                            <div className="d-flex flex-column">
                                                <Text4 className="mr-1">{va.label_name? `${va.label_name} - `:null}{va.label}</Text4>
                                                <Text4 type="secondary">Available Balance: {printRupee(va.balance, 3)}</Text4>
                                            </div>
                                        </div>
                                    </Select.Option>
                                )
                            })
                        }
                    </Select>
                    )}
                {
                    props.current_user?.merchant_active_on_sbi && account_type =='bank_account' && isSBIAccountNumber? 
                    <div>
                        <Button type='link' size='small' onClick={()=>props.generateTransferOTP("beneficiary")}>Add as Beneficiary on SBI here.</Button>This account is not yet added as a Beneficiary on SBI.
                    </div>:null
                }
            </Form.Item>

            <Form.Item label="Amount">
                {getFieldDecorator("amount", {
                    rules: validations.amount
                })(<Input autoComplete='off' prefix={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />} onChange={handleAmountChange} />)}
            </Form.Item>
            {!props?.current_user?.enable_custom_irn_for_tr ?
                <Form.Item label="Unique Request Number">
                    {getFieldDecorator("unique_request_number", {
                        rules: validations.unique_request_number
                    })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderURNExtra()} />)}
                </Form.Item> :
                <Form.Item label="Unique Request Number">
                    {getFieldDecorator("unique_request_number", {
                        rules: validations.custom_unique_request_number
                    })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderURNExtra()} />)}
                </Form.Item>
            }

            <Form.Item className="mt-2" label="Payment Method">
                {getFieldDecorator("payment_mode", {
                    rules: validations.payment_mode,
                    initialValue: get_payment_method()
                })(renderTransferTypes())}
            </Form.Item>

            {
                PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code]
                    &&
                    PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code][form.getFieldValue('payment_mode')]
                    ?
                    <Alert
                        className="mb-2"
                        type="info"
                        message={PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code][form.getFieldValue('payment_mode')].node}
                        icon={<Icon type="info-circle" />}
                        showIcon
                    /> : null
            }

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Narration">
                        {getFieldDecorator("narration", {
                            rules: validations.narration
                        })(<Input autoComplete='off' prefix={<Icon type="edit" />} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete='off' label="Schedule for later">
                        {getFieldDecorator("scheduled_for", {
                            rules: validations.scheduled_for
                        })(
                            <DatePicker
                                style={{ width: "100%" }}
                                format="YYYY-MM-DD"
                                disabledDate={disabledDate}
                            />
                        )}
                    </Form.Item>
                </div>
            </div>

            
            <div className="row">
                {yesbank_ftx_gaming && <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete="off" label="User ID">
                        {getFieldDecorator("beneficiary_user_id", {
                            initialValue: beneficiary?.beneficiary_kyc_details?.user_id,
                            rules: validations.beneficiary_user_id,
                        })(<Input autoComplete="off" prefix={<Icon type="user" />} />)}
                    </Form.Item>
                </div>}
                {(yesbank_ftx_gaming || isPowerAxis || isFtx) && <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete="off" label="PAN Number">
                        {getFieldDecorator("pan_number", {
                            initialValue: beneficiary?.beneficiary_kyc_details?.pan_number,
                            rules: validations.pan_number,
                            normalize: (value) => value && value.toUpperCase(), 
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                </div>}
                {isBeneLEIVisible && <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete="off" label="Beneficiary LEI">
                        {getFieldDecorator("bene_lei", {
                            initialValue: beneficiary?.beneficiary_kyc_details?.bene_lei,
                            rules: validations.beneficiary_lei,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                </div>}

                {isFtx && (
                    <>
                        <div className="col-sm-6">
                        <Form.Item autoComplete="off" label="Organisation Type">
                            {getFieldDecorator("organisation_type", {
                            initialValue: beneficiary?.beneficiary_kyc_details?.organisation_type,
                            rules: validations.organisation_type,
                            })(
                            <Select placeholder="Select Organisation Type">
                                {organisationTypes.map(({ label, value }) => (
                                <Select.Option key={value} value={value}>
                                    {label}
                                </Select.Option>
                                ))}
                            </Select>
                            )}
                        </Form.Item>
                        </div>

                        <div className="col-sm-6">
                        <Form.Item autoComplete="off" label="Business Model">
                            {getFieldDecorator("business_model", {
                            initialValue: beneficiary?.beneficiary_kyc_details?.business_model,
                            rules: validations.business_model,
                            })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                        </Form.Item>
                        </div>

                        <div className="col-sm-6">
                        <Form.Item autoComplete="off" label="CIN Number">
                            {getFieldDecorator("cin_number", {
                            initialValue: beneficiary?.beneficiary_kyc_details?.cin_number,
                            rules: validations.cin_number,
                            })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                        </Form.Item>
                        </div>

                        <div className="col-sm-6">
                        <Form.Item autoComplete="off" label="GST Number">
                            {getFieldDecorator("gst_number", {
                            initialValue: beneficiary?.beneficiary_kyc_details?.gst_number,
                            rules: validations.gst_number,
                            })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                        </Form.Item>
                        </div>
                    </>
                )}
            </div>

            {!props.current_user.itum && <Button
                className="pl-0 mb-2"
                type="link"
                onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
            >
                {showAdvancedOptions ? "Hide Advanced Options" : "Show Advanced Options"}
                <Icon type={showAdvancedOptions ? "down" : "right"} />
            </Button>}

            {
                showAdvancedOptions || props.current_user.itum ?
                    <div className="d-flex">
                        <Form.Item label="UDF 1">
                            {getFieldDecorator("udf1", {
                                rules: props.current_user.itum
                                    ? [
                                        ...validations.udf1,
                                        { required: true, message: "UDF1 is required" },
                                    ]
                                    : validations.udf1,
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>

                        <Form.Item className="ml-1" label="UDF 2">
                            {getFieldDecorator("udf2", {
                                rules: props.current_user.itum
                                    ? [
                                        ...validations.udf2,
                                        { required: true, message: "UDF2 is required" },
                                    ]
                                    : validations.udf2,
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>

                        <Form.Item className="ml-1" label="UDF 3">
                            {getFieldDecorator("udf3", {
                                rules: props.current_user.itum
                                    ? [
                                        ...validations.udf3,
                                        { required: true, message: "UDF3 is required" },
                                    ]
                                    : validations.udf3,
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>

                        <Form.Item className="ml-1" label="UDF 4">
                            {getFieldDecorator("udf4", {
                                rules: props.current_user.itum
                                    ? [
                                        ...validations.udf4,
                                        { required: true, message: "UDF4 is required" },
                                    ]
                                    : validations.udf4,
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>

                        <Form.Item className="ml-1" label="UDF 5">
                            {getFieldDecorator("udf5", {
                                rules: props.current_user.itum
                                    ? [
                                        ...validations.udf5,
                                        { required: true, message: "UDF5 is required" },
                                    ]
                                    : validations.udf5,
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>
                    </div> : null
            }

            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Transfer</Button>
            </div>
        </Form>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

TransferRequestForm = Form.create()(TransferRequestForm);

export default connect(mapStateToProps)(TransferRequestForm);